import { FunctionComponent } from 'react'
import { use2FAValidation } from './actions/use2FAValidation'
import { useCancelationReasonsActions } from './actions/useCancelationReasonsActions'

const GlobalActions: FunctionComponent = () => {
  use2FAValidation()
  useCancelationReasonsActions()

  return null
}

export { GlobalActions }
